module.exports = __webpack_public_path__ + "img/COMITE_MEETING.69b98965.webp";